import { tv } from 'tailwind-variants'

import { StatusBadge, statusBadgeVariants } from '@/components/ui'
import { BANKRUPTCY_STATUSES } from '@/modules/tools/bankruptcy/constants'
import { humanizeText } from '@/utils'

const bankruptcyStatusBadgeVariants = tv({
  extend: statusBadgeVariants,
  variants: {
    status: {
      [BANKRUPTCY_STATUSES.enqueued]: {
        base: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100',
        dot: 'bg-amber-500',
        icon: 'text-amber-500',
      },
      [BANKRUPTCY_STATUSES.screening]: {
        base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
        dot: 'bg-blue-500',
        icon: 'text-blue-500',
      },
      [BANKRUPTCY_STATUSES.new]: {
        base: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100',
        dot: 'bg-emerald-500',
      },
      [BANKRUPTCY_STATUSES.converted]: {
        base: 'bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-100',
        dot: 'bg-violet-500',
      },
      [BANKRUPTCY_STATUSES.dismissed]: {
        base: 'bg-neutral-100 text-neutral-500 border-neutral-200 hover:bg-neutral-150',
        dot: 'bg-neutral-400',
      },
      [BANKRUPTCY_STATUSES.failed]: {
        base: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
        dot: 'bg-red-500',
      },
    },
  },
})

interface BankruptcyStatusBadgeProps {
  status?: string
  className?: string
  showLabel?: boolean
}

export const BankruptcyStatusBadge = ({
  status,
  className,
  showLabel,
}: BankruptcyStatusBadgeProps) => (
  <StatusBadge
    slots={bankruptcyStatusBadgeVariants({ status })}
    label={humanizeText(status ?? '')}
    animated={status === BANKRUPTCY_STATUSES.screening}
    className={className}
    showLabel={showLabel}
  />
)
